<template>
<header :class="{'sneaky-mode' : sneakyMode}">
  <router-link to='/' class='logo img'></router-link>
  <el-menu mode="horizontal" class='nav logged-in' :default-active="$route.path" v-if="showNav && user.id">
    <!--回到首页 按钮-->
    <!-- <el-menu-item index="home" class='help-menu-item'>
      <a class='block-btn' href='http://ppj.io/'>
          {{ $t('actions.headbar.returnIndex') }}
          </a>
    </el-menu-item> -->
    <!-- 我的项目 按钮 -->
    <el-menu-item index="projects" :class="{'is-active' : $route.name === 'category'}">
      <router-link to='/' tag="div">{{ $t('actions.headbar.myProjects') }}</router-link>
    </el-menu-item>

    <!-- 成员管理 按钮 只对有organization的显示 -->
    <el-menu-item index="members" :class="{'is-active' : $route.name === 'members'}" v-if='organization'>
      <router-link to='/members' tag="div">{{ $t('actions.headbar.members') }}</router-link>
    </el-menu-item>

    <!-- 价格 按钮 -->
    <el-menu-item index="price" :class="{'is-active' : $route.name === 'price'}">
      <router-link to='/price' tag="div">会员服务</router-link>
    </el-menu-item>

    <!-- 会员服务 按钮 -->
    <!-- <el-menu-item index="2">{{ $t('actions.headbar.vip') }}</el-menu-item> -->
    <!-- 帮助 按钮 -->
    <el-menu-item index="help" class='help-menu-item'>
      <a class='block-btn' href='http://ppj.io/docs/' target='_blank'>
        {{ $t('actions.headbar.help') }}
        </a>
    </el-menu-item>
    <!-- <el-menu-item index="4" class="icon">
      <i class='ppj-icon-bell'></i>1
    </el-menu-item> -->
    <el-menu-item index="avatar" class='avatar-wrapper'>
      <el-popover popper-class='sub-menu header-popover' ref="popover" trigger='hover' placement="bottom-end" width="160">
        <router-link class='sub-menu-item' to="/profile">{{ $t('actions.headbar.myAccount') }}</router-link>
        <a class='sub-menu-item' @click='signOut'>{{ $t('actions.headbar.logout') }}</a>
      </el-popover>
      <el-button v-popover:popover>
        <div class='avatar img' :style="{ backgroundImage: 'url(' + user.profile_picture + ')'}" />
      </el-button>
    </el-menu-item>
  </el-menu>

  <div class='nav no-logged-in' v-if="showNav && !user.id">
    <router-link to='login' tag='el-button' v-show='this.$route.path !== "/login"'>
      {{$t('actions.headbar.login')}}
    </router-link>
    <router-link to='/register' tag='el-button' v-show="!/^\/register/.test(this.$route.path)">
      {{$t('actions.headbar.register')}}
    </router-link>
    <!-- 价格 按钮 -->
    <router-link to='/price' tag="el-button" v-show="this.$route.path !== '/price'">
      会员服务
    </router-link>
    <!-- <router-link to='wxlogin' tag='el-button' v-show="this.$route.name !== 'wxlogin'" class='wechat'>
      <i class="ppj-icon-wechat" style="margin-right: 0.5em; margin-left: -0.5em;"></i>微信登录
    </router-link> -->
    <!-- <a class='wechat-btn'>
      <el-button class='wechat'>
        <i class="ppj-icon-wechat" style="margin-right: 0.5em; margin-left: -0.5em;"></i>微信登录
      </el-button>
    </a> -->
  </div>
  <slot></slot>
</header>
</template>

<script>
export default {
  name: 'headbar',
  computed: {
    showNav() {
      return this.$store.getters['user/session'] !== null
    },
    sneakyMode() {
      return this.$store.state.sneakyMode
    }
  },
  methods: {
    signOut() {
      let vm = this
      vm.$store.dispatch('user/signOut').then(() => {
        vm.$message(vm.$t('actions.headbar.logoutMessage'))
        vm.$router.push({
          name: 'login'
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss'>
$height: 55px;
header {
    height: $height;
    overflow: hidden;
    background-color: $color-white-base;
    box-shadow: $box-shadow-base;
    padding: 0 50px;

    .logo {
        margin-top: 15px;
        width: 60px;
        height: 25px;
        float: left;
        background-image: url("~@/assets/images/logo.png");
        background-size: 100% 100%;
    }

    .avatar {
        width: 24px;
        height: 24px;
        margin: auto;
        display: inline-block;
        overflow: hidden;
        user-select: none;
        position: relative;
        border-radius: 24px;
        vertical-align: middle;
    }

    .nav {
        float: right;
        height: $height;
        line-height: $height;
        @media screen and (max-width: 600px) {
            display: none;
        }

        .help-menu-item {
            padding: 0;
            a {
                padding: 0 20px;
            }
        }

        &.logged-in {
            .el-menu-item {
                border: none;
                height: $height;
                line-height: $height;
                &:hover {
                    background-color: $color-gray-extreme-light;
                }
            }

            .avatar-wrapper {
                padding: 0;
                .el-button {
                    border: none;
                    width: 100%;
                    height: 100%;
                }
            }
        }

        &.no-logged-in {
            .wechat-btn {
                display: inline-block;
                line-height: normal;
                margin-left: $padding-base;
            }

            .el-button {
                padding: 0.6em 1em;
                color: $color-primary;
                border-color: $color-primary;

                &.wechat {
                    color: $color-green-wechat;
                    border-color: $color-green-wechat;
                }
                &:hover {
                    background-color: $color-primary;
                    color: $color-white-base;

                    &.wechat {
                        background-color: $color-green-wechat;

                        .ppj-icon-wechat {
                            color: $color-white-base;
                        }
                    }
                }
            }
        }
    }

    &.sneaky-mode {
        background-color: $color-sneaky-mode;

        .avatar-wrapper button,
        .nav.logged-in {
            background-color: $color-sneaky-mode;
        }
    }
}

.header-popover {
    margin-top: -4px !important;
    width: 120px;
}
</style>



// WEBPACK FOOTER //
// headbar.vue?67380e1c